// CÍMKE-CHIP: pöttöm, halvány felirat egy érték ELŐTT — „mi ez a szám" egy szóban (`HU 23964710-2-20`,
// `EU HU23964710`, `ID 132`).
//
// MIÉRT KÖZÖS: a számlázási profilok adószám-oszlopában született (`TaxChip`), és a használati-adat lap
// forrás-oszlopa a másodikat kérte (`ID`) — a repo DRY-szabálya szerint (CLAUDE.md 4. főszabály) a 2.
// előfordulásnál a közös rétegbe kell tenni, általánosított néven.
//
// NEM `Badge`: a shadcn badge státusz-jelölő (nagyobb, kerekebb, szín-variánsos). Ez tipográfiai előtag —
// szándékosan `text-xs`, `leading-none`, token-színekkel, hogy az érték maradjon a hangsúlyos.
export function LabelChip({ label }: { label: string }): JSX.Element {
  return (
    <span className="bg-muted text-muted-foreground rounded px-1 py-px text-xs font-medium leading-none">
      {label}
    </span>
  );
}
